import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import InspectionLocationSearchV2 from "./component";
// import { setInspectionLocation, setIsHiAvailable, setIsLocationSearchEnabled } from "../location-picker-wrapper/actions";

const mapStateToProps = ({
    location: {
        position
    },
    appointmentLocation: {leadDetailData: leadDetails}
}) => ({
    leadDetails,
    position
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InspectionLocationSearchV2);
